module.exports = __webpack_public_path__ + "static/houses_mobile-e48baad6a56351de62fc41f63ee4c205.jpg";